<template>
  <div
    class="mt-3 overflow-hidden whitespace-nowrap pl-4 pt-3 text-sm font-semibold text-primary-100"
    :class="{ invisible: reducedSidebar }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useUiStore } from '@/store/ui-store';

const uiStore = useUiStore();

const reducedSidebar = computed(() => uiStore.reducedSidebar);
</script>
